import { onMounted, onUnmounted } from 'vue';
import { usePwa } from '../stores/pwaStore';

interface UsePwaUpdateOptions {
  global?: boolean;
  /** Fired once per build, when a new worker finishes installing and waits to take over. */
  onUpdateAvailable?: () => void;
}

export const usePwaUpdate = (options?: UsePwaUpdateOptions) => {
  const { updateAvailableHandlers, ...store } = usePwa();

  const register = () => {
    if (options?.onUpdateAvailable) updateAvailableHandlers.value.push(options.onUpdateAvailable);
  };
  const unregister = () => {
    if (options?.onUpdateAvailable)
      updateAvailableHandlers.value = updateAvailableHandlers.value.filter(
        (handler) => handler !== options.onUpdateAvailable,
      );
  };

  // Most callers only read `updateAvailable` or trigger the restart, so the
  // lifecycle hooks are only reached for when a handler was actually passed.
  if (options?.global) {
    register();
  } else if (options) {
    onMounted(register);
    onUnmounted(unregister);
  }

  return store;
};
